<template>
  <el-select
    ref="select"
    v-model="valueTitle"
    :size="size"
    :placeholder="placeholder"
    :clearable="clearable"
    @change="change"
    @click.native="selClick"
  >
    <el-option
      :value="-1"
      :style="{
        width: panelWidth,
        height:'200px',
        overflow: 'auto',
        backgroundColor:'yellow',
        padding: 0
      }"
    >
      <el-tree
        ref="tree"
        v-loading="loading"
        :data="items"
        :props="{children: fChildrens,label:fName}"
        :node-key="nodeKey"
        :expand-on-click-node="false"
        default-expand-all
        highlight-current
        style="height:100%"
        @click.native="treeClick"
        @node-click="nodeClick"
      />
    </el-option>
  </el-select>
</template>

<script>
import store from '@store/index.js'
import { TreeLoop } from '@assets/site'

function ObjValid(obj){
  for (const key in obj) {
    var val = obj[key];
    if(val === undefined || val === '' || val === NaN || val === null) return false;
  }
  return true;
}

export default {
  model: {
    prop: 'value',
    event: 'changeVal'
  },
  props: {
    value: [Number, String, Array],
    nodeKey: String,
    fName: {
      type: String,
      default: 'fName'
    },
    fChildrens: {
      type: String,
      default: 'fChildrens'
    },
    url: String,
    clearable: Boolean,
    placeholder: String,
    size: String,
    panelWidth: {
      type: [Number, String]
    },
    extraParam: Object,
  },
  data: function() {
    return {
      loading: false,
      valueTitle: '',
      items: [],
      firstClick: true,
      firstRender: true
    }
  },
  computed: {
    userInfo: function() {
      return store.state.userInfo
    }
  },
  watch: {
    value: function() {
      if ((this.value || this.value === 0) && this.firstRender) {
        this.firstRender = false
        this.refresh()
      }
    }
  },
  mounted: function() {
    if ((this.value || this.value === 0) && this.firstRender) {
      this.firstRender = false
      this.refresh()
    }
  },
  methods: {
    change: function(val) {
      let item = null
      TreeLoop(this.items, x => {
        if (x[this.nodeKey] === val) {
          item = x
          return false
        }
      }, this.fChildrens)
      this.$emit('changeVal', val)
      this.$emit('change', item)
    },
    selClick: function() {
      if (this.firstClick) {
        this.firstClick = false
        if (this.items.length == 0) {
          this.firstRender = false
          this.refresh('')
        }
      }
    },
    treeClick: function() {
      const event = window.event
      event.stopPropagation()
      event.preventDefault()
    },
    nodeClick: function(item) {
      const event = window.event
      event.stopPropagation()
      event.preventDefault()

      const val = item[this.nodeKey]
      this.$emit('changeVal', val)
      this.$emit('change', item)
      this.$refs.select.blur()

      this.$nextTick(() => {
        this.refreshTitle()
      })
    },
    refresh: function() {
      this.loading = true
      var query = {}
      if (this.extraParam && ObjValid(this.extraParam)) {
        Object.assign(query, this.extraParam);
      }

      this.$httpPost(this.url, query).then(res => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }

        this.items = [res.datalist]
        this.refreshTitle()

        if (this.value) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.value)
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    refreshTitle: function() {
      TreeLoop(this.items, x => {
        if (x[this.nodeKey] === this.value) {
          this.valueTitle = x[this.fName]
          return false
        }
      }, this.fChildrens)
    }
  }
}
</script>

<style>

</style>
